import "./widget_core.js"
var req = require.context('../../../public/javascripts/backbone/apps/mosaic_tablet/', true, /\.js$/)
req.keys().forEach(req)